import {kHomeTexts} from "../../../constants/texts";
import {aboutScreenHighlightWords} from "../../../helpers/StringHelper";

export default function HomeSubtitleText() {
    // Used in HowShowCase to display subtitle
    // text

    // BUILD
    return (
        <div className={"w-full text-center px-16"}>
            <span className={"text-greyLight9 font-normal text-[20px] md:text-[22px]"}>
               {aboutScreenHighlightWords(kHomeTexts.subPunchline, ['maîtrise', 'savoir-faire', "d'apprendre en pratiquant", 'pas à pas'])}
            </span>
        </div>
    );
}